import TotpRegistration from './TotpRegistration';
import SmsPhoneNumber from './SmsPhoneNumber';
import SmsRegistration from './SmsRegistration';
import AuthenticationFactor from './AuthenticationFactor';
import UserPassword from './UserPassword';
import SmsCode from './SmsCode';
import { Default } from './Default';
import RegisterPasskey from './RegisterPasskey';

const templateMap = {
  TotpRegistration,
  SmsPhoneNumber,
  SmsCode,
  SmsRegistration,
  authenticationFactor: AuthenticationFactor,
  UserPassword,
  RegisterPasskeyIntroStep: RegisterPasskey,
};

export const getTemplate = (resource) => {
  const template = templateMap[resource.meta().type()];

  if (!template) {
    // throw new Error(`Developer config error: Unhandled source type ${resource.meta().type()}`);
    return Default;
  }

  return template;
};
